import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {HttpErrorResponse} from '@angular/common/http';
import {UserAPIService} from 'app/shared/api/user.api.service';
import {ResetPasswordResponseType} from '@app/models/auth/reset-password-response-type.enum';
import {Router} from '@angular/router';
import {SwalUtils} from '@app/shared/utils/swal.utils';
import {IState} from '@app/models/state/state.model';
import {ResetPasswordResponse} from '@app/models/auth/reset-password-response.model';
import {CommonMessages} from '@app/constants/common.messages';
import {AuthMessages} from '@app/auth/auth.messages';
import {ButtonType} from '@app/shared/components/inputs/button/button.component';

interface PageState extends IState {
  submitted: boolean;
  submitting: boolean;
}

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  public readonly eCommonMessages = CommonMessages;
  public readonly eAuthMessages = AuthMessages;
  public readonly eButtonType = ButtonType;

  state: PageState;

  form: FormGroup;

  get controlEmail(): FormControl {
    return this.form.controls.email as FormControl;
  }

  constructor(
      private userAPIService: UserAPIService,
      private router: Router,
      private swalUtils: SwalUtils
  ) {
    this.state = {
      loading: true,
      error: false,
      errorMessage: '',
      submitted: false,
      submitting: false
    };
    this.form = this.initForm();
  }

  ngOnInit(): void {
    this.state.loading = false;
  }

  private initForm(): FormGroup {
    const formGroup = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.pattern(/^(.*).@(.*).\..+$/)]),
    });

    return formGroup;
  }

  formSubmit() {
    this.state.submitted = true;

    if (this.form.invalid) {
      return;
    }
    this.state.submitting = true;

    this.userAPIService.resetUserPassword(this.controlEmail.value).subscribe(
        (response) => this.onApiResponse(response),
        (failure: HttpErrorResponse) => {
          this.state.error = true;
          this.state.errorMessage = failure.error;
          this.state.loading = false;
        }
    );
  }

  onApiResponse(response: ResetPasswordResponse): void {
    this.state.submitted = false;
    this.state.submitting = false;

    switch (response.type) {
      case ResetPasswordResponseType.EMAIL_INVALID:
      case ResetPasswordResponseType.LOGIN_DISABLED: {
        this.swalUtils.displayWarning({
          title: AuthMessages.ERROR_RESET_PASSWORD,
          text: response.message
        });
        break;
      }
      case ResetPasswordResponseType.EMAIL_PASSWORD_LOGIN_DISABLED: {
        this.swalUtils.displayWarning({
          title: AuthMessages.ERROR_RESET_PASSWORD,
          text: response.message,
          confirmButtonText: AuthMessages.RETURN_TO_LOGIN
        }).then(value => {
          if (value.isConfirmed) {
            this.router.navigateByUrl('/auth/login');
          }
        });
        break;
      }
      case ResetPasswordResponseType.SUCCESS: {
        this.swalUtils.displaySuccessSwal({
          title: AuthMessages.SUCCESS_FORGOT_PASSWORD,
          text: AuthMessages.SUCCESS_FORGOT_PASSWORD_DESCRIPTION,
          confirmButtonText: AuthMessages.RETURN_TO_LOGIN
        }).then(() => {
          this.router.navigate(['/auth/login']);
        });
        break;
      }
    }
  }

  resetForm() {
    this.state = {
      loading: false,
      error: false,
      errorMessage: '',
      submitted: false,
      submitting: false
    };
    this.form = this.initForm();
  }


  backToLogin(): void {
    this.router.navigate(['/auth/login']);
  }

}
